import { toast } from 'react-toastify';
import { queryOptions } from '@tanstack/react-query';

import { $api } from '~/lib/api-client';

type BaseInput = {
  limit?: number;
  offset: number;
  organisationId?: number;
};

const textSearchLifts = async (
  input: BaseInput & { search?: string | undefined }
) => {
  const { data, error } = await $api['/liftstatus/lift'].GET({
    params: {
      query: input,
    },
  });

  if (error) {
    console.error('[LIFTS:TEXT-SEARCH]:', error);
    toast.error('Error fetching lifts');
    throw new Error("Error fetching '/liftstatus/lift'");
  }

  if (!data) {
    throw new Error("No Data for '/liftstatus/lift'");
  }

  if ('item' in data) {
    throw new Error('Not Supported');
  }

  return data;
};

const advancedSearchLifts = async (
  input: BaseInput & {
    advancedSearch: LiftStatus.Schemas.ILiftSearchRequestDto;
  }
) => {
  const { data, error } = await $api['/liftstatus/lift'].POST({
    params: {
      query: {
        limit: input.limit,
        offset: input.offset,
      },
    },
    body: { ...input.advancedSearch, organisationId: input.organisationId },
  });

  if (error) {
    console.error('[LIFTS:ADVANCED-SEARCH]:', error);
    toast.error('Error fetching lifts');
    throw new Error("Error fetching '/liftstatus/lift'");
  }

  if (!data) {
    throw new Error("No Data for '/liftstatus/lift'");
  }

  return data;
};

export const liftSearchQueryOptions = (params: {
  page?: number;
  limit?: number;
  search?: string;
  organisationId?: number;
  advancedSearch?: LiftStatus.Schemas.ILiftSearchRequestDto | null;
}) =>
  queryOptions({
    queryKey: ['lift', 'search', params],
    queryFn: async () => {
      const { advancedSearch, limit = 20, page = 1, ...filters } = params;

      const offset = (page - 1) * limit;

      if (advancedSearch) {
        const data = await advancedSearchLifts({
          offset,
          limit,
          advancedSearch,
          ...filters,
        });
        return { ...data, pagination: { ...data.pagination, limit, offset } };
      }

      const data = await textSearchLifts({ ...filters, offset });
      return { ...data, pagination: { ...data.pagination, limit, offset } };
    },
  });
